<div class="ct-overlay">
  <div class="ct-modal">
    <div class="cm-icon">
      <img src="assets/icons/line-box.svg" alt="" />
    </div>
    <p class="cm-msg-one">{{ "NewOrder" | translate }}</p>
    <p class="cm-msg-two">
      {{ "DoYouWantToRepeatThePreviousOrderOrPlaceANewOrder" | translate }}
    </p>
    <div class="cm-btn-grp">
      <button (click)="onClickRepeat()" class="cm-btn-light">
        {{ "Repeat" | translate }}
      </button>
      <button (click)="onClickNew()" class="cm-btn-dark">
        {{ "New" | translate }}
      </button>
    </div>
  </div>
</div>
